<template>
  <v-dialog
    width="1200px"
    :scrollable="true"
    :model-value="open"
    @update:model-value="handleToggleDialog"
    v-on:keyup.esc="$emit('close')"
    v-on:keydown.stop
    v-on:cut.stop
    v-on:copy.stop
    v-on:paste.stop
  >
    <div class="dialog">
      <div class="d-flex" style="margin-bottom: 20px;">
        <v-icon icon="mds:settings" size="large" class="mr-3"></v-icon>
        <span class="text-title">Settings</span>
        <v-spacer/>
        <v-btn
          class="ml-3"
          icon="mds:close"
          variant="tonal"
          @click="$emit('close')"
        />
      </div>

      <v-tabs
        :modelValue="activeTabId"
        @update:model-value="onTabChange"
        class="new-tab settings-tabs mx-auto mt-0 mb-4"
      >
        <v-tab v-for="tab in tabs" :key="tab.id" :value="tab.id">{{ tab.title }}</v-tab>
      </v-tabs>

      <workflow-settings-template-ai v-if="activeTabId === 'AI'" :workflow="workflow" :disabled="$store.state.isWorkflowDisabled" />
      <workflow-settings-template-cards v-if="activeTabId === 'CARDS'" :workflow="workflow" :disabled="$store.state.isWorkflowDisabled" />
      <workflow-settings-template-events-roles v-if="activeTabId === 'TYPES'" :workflow="workflow" :disabled="$store.state.isWorkflowDisabled" />
      <workflow-settings-tags v-if="activeTabId === 'TAGS'" :workflow="workflow" :disabled="$store.state.isWorkflowDisabled" />
      <workflow-settings-general v-if="activeTabId === 'GENERAL'" :workflow="workflow" :disabled="$store.state.isWorkflowDisabled" />
    </div>
  </v-dialog>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import WorkflowSettingsGeneral from '@/components/WorkflowSettingsGeneral'
import WorkflowSettingsTemplateEventsRoles from '@/components/WorkflowSettingsTemplateEventsRoles'
import WorkflowSettingsTemplateAi from '@/components/WorkflowSettingsTemplateAi'
import WorkflowSettingsTemplateCards from '@/components/WorkflowSettingsTemplateCards'
import WorkflowSettingsTags from '@/components/WorkflowSettingsTags'

const { workflow, open, tabId } = defineProps({
  workflow: Object,
  open: Boolean,
  tabId: String
})

const emit = defineEmits(['close'])

const tabs = [
  { id: 'AI', title: 'AI' },
  { id: 'CARDS', title: 'Cards' },
  { id: 'TYPES', title: 'Events & Lanes' },
  { id: 'TAGS', title: 'Tags' },
  { id: 'GENERAL', title: 'General' }
]

const activeTabId = ref('AI')

const handleToggleDialog = (val) => {
  if (!val) {
    emit('close')
  }
}

const onTabChange = (tab) => {
  activeTabId.value = tab
}

watch(() => open, (newVal) => {
  nextTick(() => {
    if (!newVal) {
      activeTabId.value = 'CARDS'
    } else if (tabId) {
      activeTabId.value = tabId
    }
  })
})
</script>

<style scoped>
  .dialog {
    z-index: 10;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 19px 16px;

    border-radius: 16px;
    background: var(--light-1);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  }

  .settings-tabs {
    width: fit-content;
  }

  .dialog-title {
    vertical-align: middle;
  }

  .toolbar-divider {
    border-color: white !important;
  }
</style>
